import { createStore } from 'vuex'
import modules from './modules'
import { crud, sortable, searchable, autocomplete, accessible, selectable } from "./generator";
const _ = require("lodash");
import cloneDeep from 'lodash-es/cloneDeep';

const crudModules = crud({
  user: 'users',
  tenants: 'tenants',
  'users/all': 'users/all',
  'users/doctors': 'users/doctors',
  'users/staff': 'users/staff',
  'tenant/users': 'tenant/users',
  'tenant/doctors': 'tenant/doctors',
  'tenant/staff': 'tenant/staff',
  userImpersonations: 'userImpersonations',
  tenantEntries: 'tenantEntries',
  menu: 'menus',
  menuPoint: 'menuPoints',
  menuPointCategory: 'menuPointCategories',
  address: 'addresses',
  addressType: 'addressTypes',
  country: 'countries',
  position: 'positions',
  contact: 'contacts',
  companySize: 'companySizes',
  industry: 'industries',
  leadSource: 'leadSources',
  leadSourceCommodity: 'leadSourceCommodities',
  fieldVersion: 'fieldVersions',
  fieldType: 'fieldTypes',
  field: 'fields',
  partner: 'partners',
  streetType: 'streetTypes',
  zipCode: 'zipCodes',
  roleCategory: 'roleCategories',
  role: 'roles',
  roleGroup: 'roleGroups',
  module: 'modules',
  reminder: "reminders",
  action: 'actions',
  interaction: "interactions",
  interactionCategory: "categories",
  interactionGrouping: "groupings",
  interactionStep: "interactionSteps",
  meeting: "meetings",
  meetingOffer: 'meetingOffers',
  implementer: "implementers",
  implement: "implements",
  priority: "priorities",
  status: "statuses",
  statusStep: "statusSteps",
  billableCategory: "billableCategories",
  service: "services",
  product: "products",
  process: "processes",
  step: "steps",
  mandatory: "mandatories",
  projectType: "projectTypes",
  project: "projects",
  projectStep: "projectSteps",
  projectStepInteraction: "projectStepInteractions",
  contractType: "contractTypes",
  contract: "contracts",
  offer: "offers",
  fieldSetting: "fieldSettings",
  requiredField: "requiredFields",
  requiredRelation: "requiredRelations",
  model: "models",
  relativeFormat: "relativeFormats",
  billableImplement: "billableImplements",
  statusInitiator: "statusInitiators",
  statusInitiatorRule: "statusInitiatorRules",
  task: "tasks",
  taskPriority: "tasks/priorities",
  taskStatus: "tasks/statuses",
  taskTemplate: "tasks/templates",
  taskType: "tasks/types",
  decisionMaker: "decisionMakers",
  deadlineWarning: 'deadlineWarnings',
  microsoftAccessToken: 'microsoft/accessTokens', // Microsoft Graph api access token
  googleAccessToken: 'google/accessTokens', // Google api access token,
  vat: "vats",
  currency: "currencies",
  price: "prices",
  billableOffer: "billableOffers",
  billableContract: "billableContracts",
  billable: "billables",
  invoice: "invoices",
  invoiceType: "invoiceTypes",
  unit: "units",
  item: "items",
  requiredRepetition: "requiredRepetitions",
  campaign: "campaigns",
  billableImplementImplementer: "billableImplementImplementers",
  performance: 'performances',
  quantityTargetValue: 'targetValues',
  financialTargetValue: 'targetValues',
  customTargetValue: 'customTargetValues',
  organization: 'organizations/organizations',
  gender: 'genders',
  organizationIndustry: 'organizations/industries',
  organizationStatus: 'organizations/organizationStatuses',
  organizationType: 'organizations/organizationTypes',
  organizationOwnershipType: 'organizations/ownershipTypes',
  organizationSize: 'organizations/sizes',
  organizationGovernanceModel: 'organizations/governanceModels',
  torTPaciensSzonositoTips: 'torTPaciensSzonositoTips',
  torBno105karakteres: 'torBno105karakteres',
  vatCategories: 'vatCategories',
  currencies: 'currencies',
  coupons: 'coupons',
  couponUsages: 'couponUsages',
  usedServices: 'usedServices',
  invoices: 'invoices',
  payments: 'payments',
  patientBillingAddresses: 'patientBillingAddresses',
  deleteReasons: 'deleteReasons',
  tenantDeleteReasons: 'tenantDeleteReasons',
  onlineCalendars: 'onlineCalendars',
  consultingCloses: 'consultingCloses',
  consultingPeriods: 'consultingPeriods',
  consultingCategories: 'consultingCategories',
  locations: 'locations',
  tenantUnits: 'tenantUnits',
  rooms: 'rooms',
  icdCodes: 'icdCodes',
  bnoCodes: 'bnoCodes',
  cptCodes: 'cptCodes',
  specialties: 'specialties',
  tenantServiceGroups: 'tenantServiceGroups',
  tenantServices: 'tenantServices',
  bookings: 'bookings',
  patients: 'patients',
  waitingListEntries: 'waitingListEntries',
  forms: 'forms',
  serviceDocuments: 'serviceDocuments',
  paymentModes: 'paymentModes',
  healthFunds: 'healthFunds',
  healthInsurances: 'healthInsurances',
  units: 'units',
  career: 'organizations/careers',
  careerStage: 'organizations/careerStages',
  department: 'organizations/departments',
  division: 'organizations/divisions',
  team: 'organizations/teams',
  experience: 'organizations/experiences',
  hierarchyLevel: 'organizations/hierarchyLevels',
  hierarchicalChain: 'organizations/hierarchicalChains',
  introduction: 'organizations/introductions',
  knowledgeLevel: 'organizations/knowledgeLevels',
  location: 'organizations/locations',
  orgPosition: 'organizations/positions',
  specialization: 'organizations/specializations',
  skillLevel: 'organizations/skillLevels',
  skillScale: 'organizations/skillScales',
  skillType: 'organizations/skillTypes',
  skill: 'organizations/skills',
  positionSuperior: 'organizations/positionSuperiors',
  contributor: 'organizations/contributors',
  document: 'documents',
  newsletter: 'newsletters/newsletters',
  'newsletter/filter': 'newsletters/filters',
  'newsletter/mailList': 'newsletters/mailLists',
  'newsletter/emailList': 'newsletters/emailLists',
  'newsletter/email': 'newsletters/emails',
  'newsletter/period': 'newsletters/periods',
  'newsletter/queueDate': 'newsletters/queueDates',
  'newsletter/signature': 'newsletters/signatures',
  'newsletter/status': 'newsletters/statuses',
  'newsletter/priority': 'newsletters/priorities',
  'newsletter/setting': 'newsletters/settings',
  'newsletter/template': 'newsletters/templates',
  'newsletter/periodical': 'newsletters/periodicals',
  'newsletter/sender': 'newsletters/senders',
  'newsletter/domain': 'newsletters/domains',
    targetValue: 'targetValues',
    targetValueType: 'targetValueTypes',
    acquisition: 'acquisitions',
    projectSource: 'projects/sources',
    partnerSource: 'partners/sources',
    account: 'accounts',
  commission: 'commissions',
  // Partnership package (Appon\Partnership) — plural namespaces match the
  // generated components/forms; endpoints are served under api/partnership/{name}
  // (the package routes are prefixed with api/partnership to avoid colliding
  // with the medical package's api/services etc.).
  companies: 'partnership/companies',
  contracts: 'partnership/contracts',
  contractBookings: 'partnership/contractBookings',
  contractEmployees: 'partnership/contractEmployees',
  contractWaitingLists: 'partnership/contractWaitingLists',
  services: 'partnership/services',
  profile: 'profiles',

  // Communicator (Appon\Communicator) — read-only queue feed for the
  // System -> Communication stats page (api/communicator/messages).
  communicatorMessages: 'communicator/messages',
  applications: 'applications',
  applicationTypes: 'applicationTypes'
})

const sortableModules = sortable({
  field: 'fields',
  step: 'steps',
  currency: 'currencies',
  vat: 'vats',
  leadSource: 'leadSources',
  interaction: 'interactions',
  acquisition: 'partners/acquisitions',
  companySize: 'partners/companySizes',
  industry: 'partners/industries',
  projectSource: 'projects/sources',
  partnerSource: 'partners/sources',
  experience: 'organizations/experiences',
  gender: 'genders',
  organizationStatus: 'organizations/organizationStatuses',
  organizationSize: 'organizations/sizes',
  organizationIndustry: 'organizations/industries',
  organizationType: 'organizations/organizationTypes',
  organizationGovernanceModel: 'organizations/governanceModels',
  organizationOwnershipType: 'organizations/ownershipTypes',
  knowledgeLevel: 'organizations/knowledgeLevels',
  hierarchyLevel: 'organizations/hierarchyLevels',
  hierarchicalChain: 'organizations/hierarchicalChains',
  location: 'organizations/locations',
  specialization: 'organizations/specializations',
  skillLevel: 'organizations/skillLevels',
  skill: 'organizations/skills',
    'newsletter/priority': 'newsletters/priorities',
    'newsletter/setting': 'newsletters/settings',
  taskType: "tasks/types",
  taskPriority: "tasks/priorities",
  taskStatus: "tasks/statuses",
  applications: 'applications'
})

const searchableModules = searchable({
  implementer: {
    endpoint: 'users/implementers'
  },
  orgPosition: 'organizations/positions',
  location: 'organizations/locations',
  skill: {
    endpoint: 'organizations/skills',
    additional: {types: []}
  },
  profile: 'profiles',
})

const autocompleteModules = autocomplete({
  partner: 'partners',
  profile: 'profiles',
})

const accessibleModules = accessible({
  contract: 'contracts',
  meeting: 'meetings',
  offer: 'offers',
  invoice: 'invoices',
  implement: 'implements',
  newsletter: 'newsletters/newsletters',
  'newsletter/mailList': 'newsletters/mailLists',
  'newsletter/filter': 'newsletters/filters',
  'newsletter/periodical': 'newsletters/periodicals',
});

const selectableModules = selectable({
  user: 'users',
  partner: 'partners',
  delete_reasons: 'deleteReasons',
  // Partnership package relationship selectors (form dropdowns).
  // NOTE: these call api/partnership/{name}/select-list, which the partnership
  // package backend does not yet expose — dropdowns stay empty until it does.
  companies: 'partnership/companies',
  contracts: 'partnership/contracts',
  contractBookings: 'partnership/contractBookings',
  contractEmployees: 'partnership/contractEmployees',
  contractWaitingLists: 'partnership/contractWaitingLists',
  services: 'partnership/services',
  tenants: 'tenants',
  tenantServices: 'tenantServices',
  tenantUsers: 'tenants/users',
  // Lightweight id/name(/translation_key) dropdown sources (api/{name}/select-list).
  country: 'countries',
  streetType: 'streetTypes',
  applicationTypes: 'applicationTypes'
});

const merged = _.merge(crudModules, sortableModules, searchableModules, autocompleteModules, accessibleModules, selectableModules, modules)

// eslint-disable-next-line no-unused-vars
const store = createStore({
  modules: merged,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

const initialState = cloneDeep(store.state);

// A kilépés utáni állapot: a betöltéskori pillanatkép, de KIJELENTKEZVE. A pillanatkép a böngésző
// tárolójából indult (auth, user, app), és ha a lap belépve töltődött be, a belépett felhasználót is
// tartalmazza: visszaírva a tároló kilépés után újra belépettnek mutatta magát, a belépő lap a
// főoldalra vitt, az 401-et kapott, és körbe — dev2, 2026-10-07, több száz kérés percenként.
export function signedOutState(snapshot) {
    return {
        ...snapshot,
        auth: {...snapshot.auth, authenticated: false, permissions: [], admin: false},
        user: {...snapshot.user, authenticated: {}},
        app: {...snapshot.app, configuration: null},
    };
}

store.reset = function () {
    // A fordítás nem a felhasználóé: a kilépés (a belépő lap is ezt hívja) ne a betöltés előtti üres csomagot
    // írja vissza, mert az i18n azt átvenné, és a felület nyers kulcsokat mutatna, amíg újra nem töltik.
    store.replaceState(signedOutState({...cloneDeep(initialState), trans: cloneDeep(store.state.trans)}));
  /*Object.keys(this._actions).forEach(action => {
    if (action.endsWith('clearModule')) {
      this.dispatch(action)
    }
  }, this)*/
};

store.dispatch('notification/fetch')

// Az új értesítések pollozással érkeznek (valós idejű csatorna nincs: a Pusher-kliens 2026-09-30
// óta kivezetve, a backend `BROADCAST_CONNECTION=log`). Szinkron küldés + rövid időköz ~5–10 mp.
setInterval(() => store.dispatch('notification/poll'), 7000)

export default store;
